module.exports = __webpack_public_path__ + "static/media/Menu-6.bc657ae6.jpg";